import TradeAPAddToPortfolioSuccess from './TradeAPAddToPortfolioSuccess';

export default TradeAPAddToPortfolioSuccess;
